import React from 'react';
import './activity-indicator.css';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ActivityIndicator = props => {
    const { size, colorScheme } = props;

    const activityIndicatorClasses = classNames({
        'activity-indicator': true,
        'activity-indicator--small': size === 'small',
        'activity-indicator--large': size === 'large',
    });

    const activityIndicatorInnerClasses = classNames({
        'activity-indicator__inner': true,
        'activity-indicator__inner--small': size === 'small',
        'activity-indicator__inner--large': size === 'large',
        'activity-indicator__inner--light': colorScheme === 'light',
    });

    return (
        <div className={activityIndicatorClasses}>
            <div className={activityIndicatorInnerClasses} />
        </div>
    );
};

ActivityIndicator.defaultProps = {
    size: 'medium',
    colorScheme: 'dark',
};

ActivityIndicator.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    colorScheme: PropTypes.oneOf(['light', 'dark']),
};

export { ActivityIndicator };
